module.exports = __webpack_public_path__ + "img/video.667d10f1.png";